import { FormBuilder, FormGroup } from "@angular/forms";
import { ITaskRequest } from "../../../../modules/tasks/model/types";


export class FormUtils {
    static mapToFormGroup<T>(data: T, fb: FormBuilder): FormGroup {
      const formGroup = fb.group({});
      Object.keys(data).forEach(key => {
        if(data[key]  != null)
            formGroup.addControl(key, fb.control(data[key]));
      });
      return formGroup;
    }

    static mapToFormData<T>(data: T): FormData {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
          if(data[key]  != null)
              formData.append(key, (data as any)[key]);
      });
      return formData;
    }

    static mapFromTask<T>(task: ITaskRequest, ctor: new () => T): T {
      const data = JSON.parse(task.taskData);
        const retVal = new ctor();
        Object.keys(data).forEach(key => {
            if (data[key] != null) {
                (retVal as any)[key] = data[key];
            }
        });
      return retVal;
    }

    static toTitleCase(str: string): string {
      return str.toLowerCase().replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  }



